import { render, staticRenderFns } from "./modalCompartirBibliotecaEditar.vue?vue&type=template&id=b4a442ac"
import script from "./modalCompartirBibliotecaEditar.vue?vue&type=script&lang=js"
export * from "./modalCompartirBibliotecaEditar.vue?vue&type=script&lang=js"
import style0 from "./modalCompartirBibliotecaEditar.vue?vue&type=style&index=0&id=b4a442ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports